module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Dedication")])])]), _vm._v(" "), _c('div', {
    staticClass: "start"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n\t\t\tThis book is dedicated to my family, without whose support its inception and creation would not have been possible: to my husband, Larry, for his encouraging me to write it and his determination to see it through to the end; to my daughter, Tracy, for listening to my moans and groans when I couldn’t come up with just the right word or phrase; to my son, Corey, for not complaining about skipped or late meals; and to my sister, Deborah, for having the patience to read and critique my every word. My heartfelt thinks to each—I could not have done it otherwise.")])])]), _vm._v(" "), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-953074ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap139510.vue
// module id = 66
// module chunks = 0